export const STICKER_SIZE = 136;
